enum RepaymentInterestCalculationType {
    RepaymentPeriodocity = "REPAYMENT_PERIODOCITY",
    ActualDays = "ACTUAL_DAYS"
}
export default RepaymentInterestCalculationType